import React from 'react';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { SearchBox, Combo, TextBox } from 'fw/forms';
import { Button } from 'fw/components';
import { SetupSearch } from 'areas/shared/pages/setup';
import { AnnualSalesCombo, EmployeesRangeCombo, StateMultiCombo, GeographicMarketCombo, BusinessOwnershipMultiCombo, CertificationVOBStatusCombo } from 'areas/shared/controls';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { ConnectToVOBSearchHelpers } from 'areas/shared/helpers';

class Search extends SetupSearch {
    initialState() {
        return {
            list: [],
            loading: false,
        };
    }

    defaultForm() {
        return {
            name: "",
            nAICSCodes: [{ value: "", label: "" }],
            certificationStatusCode: null,
            veteranServiceConnectedDisabled: null,
            expirationDateFrom: null,
            expirationDateTo: null,
            approveDateFrom: null,
            approveDateTo: null,
            stateCodes: [],
            businessOwnershipIds: []
        };
    }

    initialForm() {
        const form = this.defaultForm();

        var params = queryString.parse(this.props.location.search);
        if (Object.keys(params).length !== 0) {
            form.certificationStatusCode = params.certificationStatusCode;
            form.veteranServiceConnectedDisabled = params.disabledVobStatus;
            form.expirationDateFrom = params.expirationDateFrom || null;
            form.expirationDateTo = params.expirationDateTo || null;
            form.approveDateFrom = params.approveDateFrom || null;
            form.approveDateTo = params.approveDateTo || null;
        }

        return form;
    }

    handleReset = (e) => {
        e.preventDefault();
        this.props.history.replace(this.props.location.pathname);
        this.setState({
            form: this.defaultForm()
        }, function () {
            this.search();
        });
    }

    ready = () => {
    }

	handleUpdateForm = (form) => {
		this.setState({ form });
	}

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={3} style={{ paddingRight: 10 }}>
                        <FormGroup>
                            <TextBox
                                name="keywords"
                                placeholder="Keyword Search"
                                ref={(c) => { this.focusControl = c }} />
                        </FormGroup>
                        <FormGroup>
                            <SearchBox
                                name="vobName"
                                label="name"
                                placeholder="Company/DBA Name"
                                loader={ConnectToVOBSearchHelpers.searchCompanyLoader}
                                clearable />
                        </FormGroup>
                        <FormGroup>
                            <TextBox
                                name="professionalAccreditation"
                                placeholder="Professional Accreditation" />
                        </FormGroup>
                    </Col>
                    <Col md={3} style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <FormGroup>
                            <SearchBox
                                name="veteranOwnerName"
                                label="veteranOwnerName"
                                placeholder="Veteran Name"
                                loader={ConnectToVOBSearchHelpers.searchVeteranLoader}
                                clearable />
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col md={12}>
                                    {this.state.form.nAICSCodes != null && this.state.form.nAICSCodes.length > 0 && (
                                        <React.Fragment>
                                            {ConnectToVOBSearchHelpers.renderNAICs(this.state.form, this.handleUpdateForm)}
                                        </React.Fragment>
                                    )}
									<Button type="button" bsStyle="link" onClick={() => ConnectToVOBSearchHelpers.handleAddAnotherNAIC(this.state.form, this.handleUpdateForm)}>
										Search for another NAICS Code
									</Button>
                                </Col>
                            </Row>
                        </FormGroup>
                    </Col>
                    <Col md={3} style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <FormGroup>
                            <StateMultiCombo
                                name="stateCodes"
                                placeholder="State(s)"
                                clearable />
                        </FormGroup>
                        <FormGroup>
                            <GeographicMarketCombo
                                name="geographicalMarketId"
                                placeholder="Geographical Market"
                                clearable />
                        </FormGroup>
                        <FormGroup>
                            <Row>
                                <Col md={6} style={{ paddingRight: 10 }}>
                                    <EmployeesRangeCombo
                                        name="employeeAmount"
                                        placeholder="Employees"
                                        clearable />
                                </Col>
                                <Col md={6} style={{ paddingLeft: 10 }}>
                                    <Combo
                                        name="veteranServiceConnectedDisabled"
                                        placeholder="SDVS"
                                        items={{ "True": "SDVOB", "False": "VOB" }}
                                        clearable />
                                </Col>
                            </Row>
                        </FormGroup>
                    </Col>
                    <Col md={3} style={{ paddingLeft: 10 }}>
                        <FormGroup>
                            <CertificationVOBStatusCombo
                                name="certificationStatusCode"
                                placeholder="Certification Status"
                                clearable />
                        </FormGroup>
                        <FormGroup>
                            <AnnualSalesCombo
                                name="annualSalesTypeId"
                                placeholder="Search by Revenue"
                                clearable />
                        </FormGroup>
                        <FormGroup>
                            <BusinessOwnershipMultiCombo
                                name="businessOwnershipIds"
                                placeholder="Business Ownership(s)"
                                clearable />
                        </FormGroup>
                    </Col>
                </Row>
                <Row><Col><FormGroup><br /></FormGroup></Col></Row>
            </React.Fragment >

        )
    }
}

export default withRouter(Search);



// WEBPACK FOOTER //
// ./src/areas/admin/connectToVOB/Search.js